import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.payment
 * @constructor
 */
export class OrderVerificationModel extends BaseModel {
  /**
   * @param {string} resultCode
   * @param {string} transactionId
   * @param {string} [paymentMethod]
   * @param {loavies.models.base.PriceModel} [totalPaid]
   */
  constructor({
    resultCode,
    transactionId,
    paymentMethod,
    totalPaid,
  }) {
    super()

    /** @type {string} */
    this.resultCode = resultCode

    /** @type {string} */
    this.transactionId = transactionId

    /** @type {undefined|string} */
    this.paymentMethod = paymentMethod

    /** @type {undefined|loavies.models.base.PriceModel} */
    this.totalPaid = totalPaid
  }
}

export const ORDER_VERIFICATION_RESULT_CODES = {
  REFUSED: 'Refused',
  AUTHORISED: 'Authorised',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  PENDING: 'Pending',
}
